const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {hideInMenu: true},
    component: () => import('@/views/login/login.vue'),
};
const registerRouter = {
    path: '/register',
    name: 'register',
    meta: {hideInMenu: true},
    component: () => import('@/views/login/register.vue'),
};
const homeRouter = {
    path: '/',
    name: 'index',
    redirect: '/home',
    meta: {hideInMenu: true, isCache: true},
    component: () => import('@/views/main/main.vue'),
    children: [
        {
            path: '/home',
            name: 'home',
            meta: {hideInMenu: true, isCache: true},
            component: () => import('@/views/main/home.vue'),
        },
        {
            path: '/my/info',
            name: 'my_info',
            meta: {hideInMenu: true, isCache: true},
            component: () => import('@/views/main/header-bar/my-info/my-info.vue'),
        },
    ],
};
const page401 = {
    path: '/401',
    name: 'error_401',
    meta: {hideInMenu: true},
    component: () => import('@/views/error-page/401.vue'),
};
const page404 = {
    path: '/*',
    name: 'error_404',
    meta: {hideInMenu: true},
    component: () => import('@/views/error-page/404.vue'),
};
const locking = {
    path: '/locking',
    name: 'locking',
    meta: {hideInMenu: true},
    component: () => import('@/views/main/header-bar/lockscreen/locking-page.vue'),
};

export default [loginRouter, registerRouter, homeRouter, locking, page401, page404];
